<template>
	<div class="list-wrapper">
		<slot />
	</div>
</template>
<script>
import { defineComponent } from "vue";
/**
 * List Wrapper holds the list of items (e.g. list of dashboard in dashboard management screen) in the leftmost column of the slide-out.
 */
export default defineComponent({
	name: "ListWrapper"
});
</script>
<style lang="scss">
$border-color: var(--slideout-border);

.list-wrapper {
	height: 100%;
	overflow-y: auto;
	border-right: 1px solid $border-color;
	width: 400px;
}
</style>
